var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowIntlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03516 6.71484L0.785156 1.46484C0.511719 1.21875 0.511719 0.808594 0.785156 0.535156C1.03125 0.289062 1.44141 0.289062 1.71484 0.535156L6.5 5.34766L11.2852 0.5625C11.5312 0.289062 11.9414 0.289062 12.2148 0.5625C12.4609 0.808594 12.4609 1.21875 12.2148 1.46484L6.9375 6.71484C6.69141 6.98828 6.28125 6.98828 6.03516 6.71484Z",
    fill: "#008577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIntlLogo);
export default __webpack_public_path__ + "static/media/downArrowIntlLogo.17ecacc53cb1084577576f08f0fd5388.svg";
export { ForwardRef as ReactComponent };